import { ReactNode, useLayoutEffect, useRef } from 'react'

import styles from './InfinityScroll.module.scss'

type Props = {
  onLoadMore: () => void
  isLoading: boolean
  children?: ReactNode
}

export function InfinityScroll({ isLoading, onLoadMore, children }: Props) {
  const intersectionRef = useRef<HTMLDivElement>(null)

  useLayoutEffect(() => {
    const element = intersectionRef.current
    if (!element) return
    const observer = new IntersectionObserver(
      entries => {
        const intersectionContainer = entries[0]
        if (intersectionContainer.isIntersecting && !isLoading) {
          onLoadMore()
        }
      },
      { threshold: 0.5, rootMargin: '100px' },
    )
    observer.observe(element as HTMLDivElement)
    return () => observer.disconnect()
  }, [isLoading, onLoadMore])

  return (
    <div className={styles.intersectionContainer} ref={intersectionRef}>
      {isLoading && children}
    </div>
  )
}
